<template>
	<div>
        <div class="row">
            <el-card class="pt-1 pb-4" shadow="always" :body-style="{ padding: '10px'}" style="width:100%;">
                <div class="row">
                    <div class="col-md-6">
                        <el-button size="mini" @click="$router.push('/performance-report/losses-by-product')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-6 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/revenue-and-laba')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <h4 class="text-center">KINERJA KEUANGAN KONSOLIDASI YTD MEI 2023</h4>

                <el-form  class="mt-2" label-position="top" label-width="100px">
                    <div class="row">
                        <div class="col-md-2">	
                            <el-form-item label="Bulan:">
                                <el-select v-model="month" clearable filterable placeholder="Select Month" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">	
                            <el-form-item label="Tahun:" style="min-width:85px;">
                                <el-select v-model="year" clearable filterable placeholder="Select Year" size="medium" style="width:100%;">
                                    <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-1">	
                            <el-form-item label=" ">
                                <el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply</el-button>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <el-table
                            :data="tableData"
                            stripe
                            style="width: 100%; font-size:12px;"
                            :header-cell-style="{paddingTop: '8px', paddingBottom: '2px', background: '#F5F7FA'}"
                            :header-row-style="{padding:'0px'}"
                            :cell-style="{padding: '8px 0px', borderBottom: '1px solid #EBEEF5', borderRight: '0px solid #EBEEF5'}"   >

                            <el-table-column
                                fixed
                                prop="title"
                                label="Laporan Laba / Rugi"
                                header-align="center">
                            </el-table-column>

                            <el-table-column
                                label="Real 2022"
                                header-align="center">

                                <el-table-column
                                    label="Ytd Mei"
                                    header-align="center">
                                    <el-table-column
                                        prop="ytd_month"
                                        label="A"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                            </el-table-column>

                            <el-table-column
                                label="Target 2023"
                                header-align="center">
                                <el-table-column
                                    label="RKAP"
                                    header-align="center">
                                    <el-table-column
                                        prop="target_rkap"
                                        label="B"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                                <el-table-column
                                    label="Ytd Mei"
                                    header-align="center">
                                    <el-table-column
                                        prop="target_ytd_month"
                                        label="C"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                            </el-table-column>

                            <el-table-column
                                label="Real 2023"
                                header-align="center">
                                <el-table-column
                                    label="Ytd Mei"
                                    header-align="center">
                                    <el-table-column
                                        prop="real_ytd_month"
                                        label="D"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                            </el-table-column>

                            <el-table-column
                                label="% Achievement"
                                header-align="center">
                                <el-table-column
                                    label="RKAP"
                                    header-align="center">
                                    <el-table-column
                                        prop="achievement_rkap"
                                        label="E = D/C"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                            </el-table-column>

                            <el-table-column
                                label="Growth YoY"
                                header-align="center">
                                <el-table-column
                                    label="Ytd Mei"
                                    header-align="center">
                                    <el-table-column
                                        prop="growth_yoy_month"
                                        label="F = (D-A)/C"
                                        header-align="center"
                                        align="right"
                                        :width="columnWidth">
                                    </el-table-column>
                                </el-table-column>

                            </el-table-column>

                        </el-table>
                    </div>

                    <div class="col-md-4 p-0" style="border:1px solid #2F5597;">
                        <div class="text-center" style="background:#2F5597;">
                            <h6 style="color:#ffffff;">JUSTIFIKASI KINERJA KEUANGAN</h6>
                        </div>
                        <div class="p-3">
                            <div style="color:#1D7BBB;"><b>Realisasi Beban Pokok Penjualan</b></div>
                            <p style="text-align:justify;">Realisasi beban pokok penjualan dan beban langsung lainnya 112% melebihi target RKAP Ytd Mei 2023, sejalan dengan peningkatan penjualan 110% dan pergantian spare part dispenser dan maintenance SPBU Rp. 6,82 M, Sarfas IT/internet Rp. 4,45 M.</p>
                            <div style="color:#1D7BBB;"><b>Laba Bruto</b></div>
                            <p style="text-align:justify;">Realisasi Laba bruto under 29% dari target RKAP Ytd Mei 2023 karena dampak dari penurunan Margin SPBU KSO. Besaran dampak penurunan Rp. 41,73 Miliar (Jan=Rp. 8,77 M + Feb=7,83 M + Mar=8,74 M + Apr=7,79 M + Mei 8,6 M).</p>
                            <div style="color:#1D7BBB;"><b>Pajak Penghasilan</b></div>
                            <p style="text-align:justify;">Realisasi Pajak Penghasilan 197% melebihi RKAP 2023 karna realisasi Pajak Mei merujuk dari perhitungan PPh 25 tahun 2022, sedangkan di RKAP memperhitungkan Pph 25 di tahun 2021.</p>

                        </div>
                    </div>
                </div>
            </el-card>

        </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'

export default
{
	extends: KinerjaKeuangan,
	components: { 
		//ReportParamSelect,
	},

	data() {
		return {
            columnWidth : 120,

            options: {
                months:[
                    {value:'1', name: 'Januari'},
                    {value:'2', name: 'Februari'},
                    {value:'3', name: 'Maret'},
                    {value:'4', name: 'April'},
                    {value:'5', name: 'Mei'},
                    {value:'6', name: 'Juni'},
                    {value:'7', name: 'Juli'},
                    {value:'8', name: 'Agustus'},
                    {value:'9', name: 'September'},
                    {value:'10', name: 'Oktober'},
                    {value:'11', name: 'November'},
                    {value:'12', name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                ],
            },
            month: '6',
            year: '2023',

            loading: {
                table: false,
            },


            tableData: [
                {
                    title: 'Revenue',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Pokok Penjualan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba / (Rugi) Bruto',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Usaha',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba / (Rugi) Usaha',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Pendapatan / Beban lain',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Beban Pajak Penghasilan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Laba/ (Rugi) Tahun Berjalan',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'EBITDA',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'EBITDA Margin',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
                {
                    title: 'Profit Margin',
                    ytd_month: '7.060.788',
                    target_rkap: '21.586.362',
                    target_ytd_month: '657.823',
                    real_ytd_month: '266.196',
                    achievement_rkap: '110%',
                    growth_yoy_month: '36%',
                }, 
            ],
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');
    },
    methods: {

    },
}
</script>